import { StyleSheet, Text, View } from 'react-native';
import { theme } from '@/constants/theme';

export default function Folder({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <View style={s.shell}>
      <View style={s.tab} />
      <Text style={s.title}>{title}</Text>
      <Text style={s.sub}>{subtitle}</Text>
    </View>
  );
}

const s = StyleSheet.create({
  shell: { backgroundColor: '#1A2242', borderRadius: 14, borderWidth: 1, borderColor: '#39518D', padding: 12, paddingTop: 18 },
  tab: { position: 'absolute', top: -1, right: 14, width: 44, height: 11, borderTopLeftRadius: 8, borderTopRightRadius: 8, backgroundColor: '#2A3B6D' },
  title: { color: '#fff', fontFamily: theme.fonts.bold, textAlign: 'right' },
  sub: { color: '#A2B2E3', fontFamily: theme.fonts.regular, marginTop: 4, textAlign: 'right' },
});
